import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/APIClient';
const TransferForm = ({ onScamDetected, amount, onAmountChange, recipientAccount, onRecipientAccountChange }) => {
    const [formData, setFormData] = useState({
        fromAccount: 'KF-PB-789456',
        toAccount: recipientAccount,
        amount: amount,
        description: '',
        userId: 'user123'
    });
    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    // Sync formData with lifted state when props change
    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            toAccount: recipientAccount,
            amount: amount
        }));
    }, [amount, recipientAccount]);
    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const response = await apiClient.fetch(`/api/balance/${formData.fromAccount}`);
                setBalance(response.balance);
            }
            catch (error) {
                console.error('Failed to fetch balance:', error);
                setBalance(12500);
            }
        };
        fetchBalance();
    }, [formData.fromAccount]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'amount' ? parseFloat(value) || 0 : value
        }));
        // Also update lifted state
        if (name === 'amount') {
            onAmountChange(parseFloat(value) || 0);
        }
        else if (name === 'toAccount') {
            onRecipientAccountChange(value);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResult(null);
        try {
            const response = await apiClient.fetch('/api/transfer', {
                method: 'POST',
                body: JSON.stringify(formData),
            });
            let data;
            // Check if response is ok and handle potential non-JSON responses
            if (!response.success) {
                data = {
                    success: false,
                    message: response.message || 'Transfer failed',
                    scamDetected: response.scamDetected
                };
            }
            else {
                data = response;
            }
            setResult(data);
            if (data.scamDetected) {
                onScamDetected(data.supportAccessToken);
            }
            else if (data.success) {
                setFormData(prev => ({
                    ...prev,
                    toAccount: '',
                    amount: 0,
                    description: ''
                }));
            }
        }
        catch (error) {
            console.error('Transfer failed:', error);
            setResult({
                success: false,
                message: 'Transfer failed. Please try again.'
            });
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsxs("div", { className: "transfer-container", id: "transfer-container", children: [_jsxs("div", { className: "transfer-header", children: [_jsx("h1", { className: "transfer-title", children: "Wire Transfer" }), _jsx("p", { className: "transfer-subtitle", children: "Secure international and domestic transfers" })] }), _jsxs("div", { className: "account-balance", children: [_jsx("div", { className: "balance-label", children: "Available Balance" }), _jsxs("div", { className: "balance-amount", children: ["$", balance.toLocaleString()] })] }), result && (_jsx("div", { className: `alert ${result.success ? 'alert-success' : 'alert-error'}`, children: result.message })), _jsxs("form", { className: "transfer-form", onSubmit: handleSubmit, children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { className: "form-label", children: "From Account" }), _jsx("input", { type: "text", name: "fromAccount", value: formData.fromAccount, onChange: handleInputChange, className: "form-input", readOnly: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "form-label", children: "Beneficiary Account *" }), _jsx("input", { type: "text", name: "toAccount", value: formData.toAccount, onChange: handleInputChange, className: "form-input", placeholder: "Enter IBAN or account number", required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "form-label", children: "Amount (USD) *" }), _jsx("input", { type: "number", name: "amount", value: formData.amount || '', onChange: handleInputChange, className: "form-input", placeholder: "0.00", min: "0.01", step: "0.01", required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "form-label", children: "Transfer Reference" }), _jsx("textarea", { name: "description", value: formData.description, onChange: handleInputChange, className: "form-input form-textarea", placeholder: "Optional: Purpose of payment or reference" })] }), _jsx("button", { type: "submit", className: "transfer-button", disabled: loading, children: loading ? 'Processing Transfer...' : 'Execute Transfer' })] })] }));
};
export default TransferForm;
